module.exports = __webpack_public_path__ + "img/int-paper-logo.1f8f1951.jpg";